import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import RootLayout from "../../../layout";
import httpService from "../../../../services/http.service";
import { getCMSApiRoute } from "../../../../utils/api.utils";
import GenreChildContent from "../../../../components/genreChild/content";
import GenreParentContent from "../../../../components/genreParent/content";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../../../redux/Slices/loading.slice";
import PageLayout from "../../../../components/layout/PageLayout";

const ChildGenre = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const contentKind = searchParams.get("kind");
  const dispatch = useDispatch();

  const generateError = ({ error }) => {
    if (error) console.log(error);
    toast.error(
      "خطا در دریافت اطلاعات، لطفا اتصال اینترنت را بررسی کرده سپس مجددا تلاش فرمائید"
    );
    return {
      success: false,
      isParent: false,
      children: [],
      contents: [],
      result: {},
    };
  };

  async function getdata(slug) {
    try {
      const response = await httpService.get(getCMSApiRoute("genre"), {
        params: {
          pageIndex: 100,
          pageNumber: 1,
          slug,
        },
      });

      if (!response.status === 200) {
        return generateError();
      }

      const { data } = response.data;

      if (!data || !data.result) {
        return generateError();
      }

      const { contents, result } = data;

      if (result.children.length > 0) {
        return {
          success: true,
          isParent: true,
          result,
          children: result.children,
          contents,
        };
      } else {
        return {
          success: true,
          isParent: false,
          result,
          children: [],
          contents,
        };
      }
    } catch (error) {
      return generateError({ error });
    }
  }

  useEffect(() => {
    // Start loading - disables sidebar navigation
    dispatch(startLoading("در حال بارگذاری ژانر..."));

    getdata(slug).then((data) => {
      setData(data);
      setLoading(false);
      // Stop loading - re-enables sidebar navigation
      dispatch(stopLoading());
    });
  }, [slug]);

  // Render based on isParent status
  const renderContent = () => {
    if (loading || !data.success) return null;

    if (!data.isParent) {
      return <GenreChildContent data={data} slug={slug} contentKind={contentKind} />;
    }
    return <GenreParentContent data={data} />;
  };

  return (
    <RootLayout>
      <PageLayout loading={loading} skeletonType="genre">
        {renderContent()}
      </PageLayout>
    </RootLayout>
  );
};

export default ChildGenre;

